import { Reducer } from 'redux';

import {
  SearchSessionActivateSearchBoxAction,
  SearchSessionEndAction,
  SearchSessionSubmitSearchAction,
} from '../../domains/searchSession/types';
import {
  TypeaheadEnterAction,
  TypeaheadLeaveAction,
  TypeaheadPendingAction,
  TypeaheadSelectMentionItemAction,
  TypeaheadSelectPickerItemAction,
} from '../../domains/typeahead/actions.types';

import { SearchSession } from './types';

export type SearchSessionIdAction =
  | SearchSessionSubmitSearchAction
  | SearchSessionActivateSearchBoxAction
  | SearchSessionEndAction
  | TypeaheadEnterAction
  | TypeaheadLeaveAction
  | TypeaheadSelectPickerItemAction
  | TypeaheadSelectMentionItemAction
  | TypeaheadPendingAction;

const initialState: SearchSession = {
  conversationId: undefined,
  logicalId: undefined,
};

const startSearchSession = (
  state: SearchSession,
  { payload }: TypeaheadEnterAction | SearchSessionActivateSearchBoxAction
) => ({
  ...state,
  conversationId: payload.conversationId,
  conversationStart: payload.conversationStart,
  logicalId: payload.logicalId,
});

const endSearchSession = (state: SearchSession) => ({
  ...state,
  conversationId: undefined,
  conversationStart: undefined,
  logicalId: undefined,
});

const updateSearchSessionLogicalId = (
  state: SearchSession,
  { payload }: TypeaheadPendingAction | SearchSessionSubmitSearchAction
) => ({
  ...state,
  logicalId: payload.logicalId,
});

const reducer: Reducer<SearchSession, SearchSessionIdAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SEARCH.SUBMIT':
      return updateSearchSessionLogicalId(state, action);
    case 'SEARCH.ACTIVATE_SEARCHBOX':
      return startSearchSession(state, action);
    case 'SEARCH.END_SESSION':
      return endSearchSession(state);
    case 'TYPEAHEAD.ENTER':
      return startSearchSession(state, action);
    case 'TYPEAHEAD.SELECT_PICKER_ITEM':
      return endSearchSession(state);
    case 'TYPEAHEAD.SELECT_MENTION_ITEM':
      return endSearchSession(state);
    case 'TYPEAHEAD.LEAVE':
      return endSearchSession(state);
    case 'TYPEAHEAD.LOAD_PENDING':
      return updateSearchSessionLogicalId(state, action);
    default:
      return state;
  }
};

export default reducer;
